import { isValidJsonString } from './isValidJsonString';
import { parseJSON } from './parseJson';

export const JsonService = {
  isValidJsonString,
  parseJSON,
};
